<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      label="Danh sách chặng bay"
      prop="flightRouteList"
    >
      <div class="flex-row flex__left">
        <el-button class="btnPlain" @click="addRoutes">
          <i class="fas fa-plus-circle"></i>
          Thêm chặng bay
        </el-button>
      </div>
    </el-form-item>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="routes"
        v-if="routes && routes.length"
      >
        <el-table-column width="40" type="index">
          <template #header
          >#
          </template>
        </el-table-column>

        <el-table-column
          label="Điểm đi"
          show-overflow-tooltip
          property="airportFrom"
        >
          <template slot-scope="scope">
            <p>{{ getAirportLabel(scope.row.airportFromId) }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Điểm đến"
          show-overflow-tooltip
          property="airportTo"
        >
          <template slot-scope="scope">
            <p>{{ getAirportLabel(scope.row.airportToId) }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Thời gian bay yêu cầu"
          show-overflow-tooltip
          property="flightTimeEstimate"
          align="right"
        >
          <template slot-scope="scope">
            <p>{{ getDatetimeLabel(scope.row.flightTimeEstimate) }}</p>
          </template>
        </el-table-column>

        <el-table-column align="center" header-align="left" width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top" content="Sửa">
              <i
                class="el-icon-edit font-size__large color__blue clickable"
                @click="edit(scope.row)"
              ></i>
            </el-tooltip>
            <el-tooltip placement="top" content="Xóa">
              <i
                class="el-icon-circle-close font-size__large color__red clickable"
                @click="removeRoute(scope.row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <hc-maybay-add-route-dialog
      v-if="isEnableDialogAdd"
      :isOpen="isOpenDialogAdd"
      :route="selectedRoute"
      @closeDialog="isOpenDialogAdd = false"
      @dialogClosed="isEnableDialogAdd = false"
      @submit="addRoute"
    ></hc-maybay-add-route-dialog>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import HcMaybayAddRouteDialog from "./hc-maybay-add-route-dialog";
import hcCfgAirportService from "../../../services/maybay/hcCfgAirportService";
import h from "../../../services/h";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "hc-maybay-routes",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: {HcMaybayAddRouteDialog},
  props: ["objectId", "objectType", "deptId"],

  data() {
    return {
      routes: [],
      airports: [],
      isOpenDialogAdd: false,
      isEnableDialogAdd: false,
      selectedRoute: null
    };
  },

  watch: {
    isOpenDialogAdd(newValue) {
      if (newValue) this.isEnableDialogAdd = newValue;
      else if (this.selectedRoute) this.selectedRoute = null;
    }
  },

  created() {
    this.loadAirports();
  },

  methods: {
    edit(route) {
      this.selectedRoute = route;
      this.isOpenDialogAdd = true;
    },

    getData() {
      return this.routes;
    },

    getDatetimeLabel(time) {
      return time ? dateFormatter(time) : "-";
    },

    getAirportLabel(airportId) {
      let airport = h.find(this.airports, item => item.id === airportId);
      return airport ? airport.placeName : null;
    },

    loadAirports() {
      return hcCfgAirportService
        .findAll()
        .then(response => (this.airports = response.data));
    },

    addRoutes() {
      this.isOpenDialogAdd = true;
    },

    addRoute(event) {
      let route = event.result;
      !this.selectedRoute
        ? this.routes.push(route)
        : this.bindDataToForm(this.selectedRoute, route);
      this.isOpenDialogAdd = false;
    },

    bindDataToForm(form, route) {
      form.airportFromId = route.airportFromId;
      form.airportToId = route.airportToId;
      form.flightTimeEstimate = route.flightTimeEstimate;
    },

    removeRoute(route) {
      this.routes.splice(this.routes.indexOf(route), 1);
    }
  }
};
</script>

<style scoped>
.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-routes.vue